var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,2.48689958e-14 C15.5228475,2.48689958e-14 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 1.13686838e-13,15.5228475 1.13686838e-13,10 C1.13686838e-13,4.4771525 4.4771525,2.48689958e-14 10,2.48689958e-14 Z M11.6852207,11.3089841 L11.6330816,11.3095783 C11.4077206,11.326546 11.2387844,11.5229923 11.2557522,11.7483533 L11.2557522,11.7483533 L11.5805181,16.0618025 C11.587317,16.1521026 11.6238766,16.2375968 11.6844702,16.3048927 C11.8356929,16.4728426 12.0944335,16.4864026 12.2623834,16.3351799 L12.2623834,16.3351799 L16.1934899,12.7955957 C16.2607858,12.7350022 16.3060818,12.6537978 16.3222823,12.5647032 C16.3627137,12.3423503 16.2152373,12.1293215 15.9928844,12.0888901 L15.9928844,12.0888901 L11.737012,11.315025 C11.7027416,11.3087935 11.6678157,11.3069631 11.6330816,11.3095783 Z M8.58975655,3.84829886 C8.43853378,3.68034897 8.17979322,3.66678895 8.01184333,3.81801172 L8.01184333,3.81801172 L4.08073686,7.35759588 C4.01344094,7.4181894 3.96814495,7.49939378 3.95194445,7.58848844 C3.911513,7.81084129 4.05898943,8.02387006 4.28134228,8.06430151 L4.28134228,8.06430151 L8.53721468,8.83816655 C8.57148515,8.84439811 8.60641103,8.8462285 8.64114514,8.84361332 C8.86650616,8.82664556 9.03544227,8.63019927 9.0184745,8.40483826 L9.0184745,8.40483826 L8.69370857,4.09138905 C8.68690975,4.00108904 8.65035007,3.91559479 8.58975655,3.84829886 Z",
    id: "Combined-Shape-Copy",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullscreen);
export default __webpack_public_path__ + "static/media/exit-fullscreen.64cf6ba974f6c1dde0d2af95a54225ab.svg";
export { ForwardRef as ReactComponent };